export default "__VITE_ASSET__oHhX8oWU__"